<template>
    <div>
        <Modal v-model="show"
            :width="1300"
            :footer-hide="true"
            title="生成发货单"
			:scrollable="true"
            @on-visible-change="onShowChange">
            <Spin v-if="innerSpin"
                size="large"
                fix></Spin>
            <Card :padding="0"
                :bordered="false"
                :dis-hover="true">
                <Row :gutter="16">

                    <Col span="24">
                    <Form label-position="top"
                        class="form-input-no-outline">
                        <Row :gutter="16">
                            <Col span="4">
                            <FormItem label="订单号">
                                <Input :value="orderRecord.billCode"
                                    readonly></Input>
                            </FormItem>
                            </Col>
                            <Col span="4">
                            <FormItem label="苗场">
                                <Input :value="orderRecord.seedFarmName"
                                    readonly></Input>
                            </FormItem>
                            </Col>
                            <Col span="4">
                            <FormItem label="定单时间">
                                <Input :value="formatDateTimeString(orderRecord.depositBillRecordCreateAt)" readonly></Input>
                            </FormItem>
                            </Col>
                            <Col span="2">
                            <FormItem label="周期">
                                <Input :value="orderRecord.weekSeq"
                                    readonly></Input>
                            </FormItem>
                            </Col>
                            <Col span="4">
                            <FormItem label="发货时间">
								<Input v-model="sendDeliveryDate" :value="formatDateString(orderRecord.depositBillRecordSendProductDate)"></Input>
                            </FormItem>
                            </Col>
                            <Col span="2">
                            <FormItem label="支付状态">
                                <Input :value="orderRecord.paidStatus"
                                    readonly></Input>
                            </FormItem>
                            </Col>
                            <Col span="2">
                            <FormItem label="定单总额(元)">
                                <Input :value="orderRecord.totalMoneyActual" readonly></Input>
                            </FormItem>
                            </Col>
                            <Col span="2">
                            <FormItem label="待付金额(元)">
                                <Input :value="orderRecord.paidStatus=='全额支付'?0:orderRecord.remainingSum" readonly></Input>
                            </FormItem>
                            </Col>
                        </Row>
						<Row :gutter="24">
							<Col span="5">
							<FormItem label="省份" prop="depositBillRecordProvince">
								<Select v-model="orderRecord.depositBillRecordProvince" filterable clearable placeholder="请选择省" @on-change="onProvinceChange">
									<Option v-for="item in provinceOptions"
										:key="item.regionUuid"
										:value="item.regionUuid">{{ item.regionName }}</Option>
								</Select>
							</FormItem>
							</Col>
							<Col span="5">
							<FormItem label="城市" prop="depositBillRecordCity">
								<Select v-model="orderRecord.depositBillRecordCity" filterable clearable placeholder="请选择市" @on-change="onCityChange">
									<Option v-for="item in cityOptions"
										:key="item.regionUuid"
										:value="item.regionUuid">{{ item.regionName }}</Option>
								</Select>
							</FormItem>
							</Col>
							<Col span="5">
							<FormItem label="区/县" prop="depositBillRecordDist">
								<Select v-model="orderRecord.depositBillRecordDist" filterable clearable placeholder="请选择区/县">
									<Option v-for="item in distOptions"
										:key="item.regionUuid"
										:value="item.regionUuid">{{ item.regionName }}</Option>
								</Select>
							</FormItem>
							</Col>
							<Col span="9">
							<FormItem label="客户地址">
							    <Input v-model="orderRecord.receiptFullAddress"></Input>
							</FormItem>
							</Col>
						</Row>
						<Row :gutter="24">
						    <Col span="4">
						    <FormItem label="关联销售单号">
						        <Input :value="orderRecord.preSaleOrderRecordCode" readonly></Input>
						    </FormItem>
						    </Col>

							<Col span="10">
							<FormItem label="苗场备注" v-if="$checkAccessArray(['B','C'])">
							    <Input v-model="orderRecord.remark" placeholder="提醒:点击保存按扭可保存苗场备注!" type="textarea"></Input>
							</FormItem>
							<FormItem label="苗场备注" v-if="$checkAccessArray(['S','G'])">
							    <Input :value="orderRecord.remark" readonly type="textarea"></Input>
							</FormItem>
							</Col>
						</Row>
						<Row :gutter="24">
							<Col span="8">
							<FormItem label="客户备注" v-if="$checkAccessArray(['S','B'])">
							    <Input :value="orderRecord.customerMsg" readonly type="textarea"></Input>
							</FormItem>
							</Col>
							<Col span="6">
							<FormItem label="佣金比例">
							    <Input :value="orderRecord.depositBillDetailSalesAssociateCommissionPercent" readonly ></Input>
							</FormItem>
							</Col>
							<!-- <Col span="4">
							<FormItem
								label="选择用友部门"
								class="custom-required-field"
								v-if="orderRecord.seedFarmName === '洋桔梗种苗部'"
							>
								<template #label>
								<span class="custom-asterisk">*</span>
								选择用友部门
								</template>
								<Select
									v-model="orderRecord.deptYSType"
									filterable
									clearable
									@on-change="onDeptYSTypeChange"
									>
										<Option
											v-for="item in DEPT_YS_TYPE_OPERATION"
											:value="item.value"
											:key="item.value"
										>{{ item.label }}</Option>
								</Select>
							</FormItem>
							</Col> -->
							<!-- <Col span="8">
							<FormItem label="废单号" v-if="$checkAccessArray(['S','B'])">
							    <Input readonly :value="orderRecord.depositBillRecordCodeOld" type="text" style="width:74%;margin-right:20px;"></Input><a v-if="orderRecord.depositBillRecordUuidOld!=null" href="#" @click="showAbandonedDepositDetailModal(orderRecord.depositBillRecordUuidOld)">查看</a>
							</FormItem>
							</Col> -->
						</Row>
						<Row :gutter="24">
						   <Col  span="4">
						    <FormItem label="其它优惠">
								<InputNumber :value="depositBillDetailsArtiDiscUnitDisAmount" :precision="4"  :step="0.0001"  :min="0" 	:formatter="value=>parseFloat(value.toString())"  	@on-change="changeArtiDiscUnitDisAmount($event)"  :active-change="false"></InputNumber>
						    </FormItem>
						    </Col>
						</Row>
                        <Row :gutter="24">
                            <Col span="24">
							<!-- <div style="width: 100%;text-align: right;" v-if="$checkAccessArray(['B','C','S','G'])&&(orderRecord.orderStatus=='提交'||orderRecord.orderStatus=='修改')&&orderRecord.paidStatus=='定金已支付'">
								 <Poptip
								   confirm
								   placement="left"
								   title="以第一行品种的单价为准,是否将全部品种的单价改成一样？"
								   @on-ok="updatePreSalePlanPrice"
								   @on-cancel="cancel" style="margin-right: 20px;text-align: left;">
								   <Button type="error">批量修改单价</Button>
								</Poptip>
								<Poptip
								   confirm
								   placement="left"
								   title="请确认信息是否无误？"
								   @on-ok="saveDetailInfo"
								   @on-cancel="cancel" style="text-align: left;">
								   <Button type="error">批量保存</Button>
								</Poptip>
							</div> -->
							<FormItem>
                                <div slot="label"><b>定金单明细</b>
                                </div>
                                <Table ref="mainTable"
                                    size="small"
                                    :columns="orderDetail.columns"
                                    :data="orderDetail.rows"
                                    stripe
                                    border />
                            </FormItem>
                            <FormItem>
                                <div slot="label"><b>发货单明细</b>
                                </div>
                                <Table ref="mainTable"
                                    size="small"
                                    :columns="preOrderDetail.columns"
                                    :data="preOrderDetail.rows"
                                    stripe
                                    border />
                            </FormItem>
                            </Col>
                        </Row>
                    </Form>

                    </Col>
                </Row>
				<div style="text-align:right;">
					<Button type="warning" style="margin-right: 20px" v-if="isCanBeforehand"
					@click="earlyTerminationDeposit()">提前结束发货</Button>
					<Button type="info" style="margin-right: 10px"
					@click="generatePreSaleDelivery(0)">保存</Button>
					<Button type="primary"  style="margin-right: 10px"
					@click="generatePreSaleDelivery(1)">保存并提交</Button>
				    <Button type="error"
				        @click="show=false">关闭</Button>
				</div>
            </Card>
			<payModalDetail ref="PayModal" />
        </Modal>
		<!-- <AbandonedDepositDetail ref="abandonedDepositDetailModal" /> -->
    </div>
</template>

<script>
import payModalDetail from '../../sale-management/sale-help-put-cart/pay';
import { formatDateString, formatDateTimeString } from '@/libs/logic';
import CurrencyInput from '@/components/number-input/currency-input';
import DecimalInput from '@/components/number-input/decimal-input';
import IntegerInput from '@/components/number-input/integer-input';
// import AbandonedDepositDetail from '@/view/sale-management/abandoned/abandoned-deposit-detail';
import {
    dateRender,
    dateTimeRender,
    numberDecimalMul,
    numberDecimalAdd
} from '@/libs/tableRowTimeRender';
import {
    getDepositBillOrderDetail, getPreDeliveryByDepositUuid, deleteDepositBillDetailByUuid, updateDepositBillDetailByUuid, printDepositBillRecord, generatePreSaleDelivery, earlyTerminationDeposit
} from '@/api/modules/preSale-management/deposit-order';
import {
    ORDER_PAID_STATUS_TYPE_DEPOSIT_PAID
} from '@/view/preSale-management/preSale-order/PreSaleOrderStatus';
import {
    FILE_SERVER
} from '@/api/modules/files';
import { webGetAllRegion } from '@/api/modules/system-management/region-management';
import search from '@/libs/search';
import { readonly } from 'vue';
import { quantity } from 'echarts/lib/util/number';
import { deleteSerialByUuid } from '@/api/modules/product-management/serial-management';
import { DEPT_YS_TYPE_OPERATION } from '@/view/common/pre-sale-delivery';
import { productQuantityIsRoundedMixin } from "@/view/mixins/ProductQuantityIsRounded.js";
export default {
    name: 'GeneratePresaleOrderDetail',
    components: {
        // AbandonedDepositDetail,
        CurrencyInput,
        DecimalInput,
        IntegerInput,
        payModalDetail
    },
    mixins: [productQuantityIsRoundedMixin],
    data() {
    	return {
            DEPT_YS_TYPE_OPERATION,
            depositBillDeposit:0,    //定金单已付款定金
            setDeposit:0,    //此发货单设置的定金
            setFarmPackageFee:0,  //此发货单设置的手工包装费
            setFarmDeliveryFee:0,  //此发货单设置的手工配送费
            setVoucherAmountFee:0,  //手动录入代金券金额
            preSaleDeliveryRecords:[],   //此定金单已生成的发货单
            depositProducts:[],            //定金详情单中还有的产品列表
            depositBillDetailsArtiDiscUnitDisAmount:0, //批量设置其它优惠
            sendDeliveryDate:'',
            show: false,
            innerSpin: false,
            depositBillRecordUuid: '',
            depositBillRecordUuidArray: [],
            orderRecord: {
                deptYSType: 0
            },
            pageLoading: false,
            allRegions: [],
            provinceOptions: [],
            cityOptions: [],
            distOptions: [],
            orderDetail: {
                columns: [
                    {
						    title: '序号',
                        align: 'center',
                        width:'50',
						    render:(h, params) =>{
                            if(params.row.productCode==''||params.row.productCode=='定金收取(%)'){
									 h('span', '');
                            }
                            else{
                                return h('span', params.index+1);
                            }
						    }
                    },
                    {
                        title: "品种编号",
                        key: "productCode",
                        render:(h, params) =>{
                            if(!params.row.productCode||params.row.productCode=='定金收取(%)'){
								  return h('span', '');
                            }
                            else {
                                return h('span', params.row.productCode);
                            }
						    }
                    },
                    {
                        title: "品种名称",
                        key: "productName",
                        render:(h, params) =>{
                            if(params.row.productCode=='定金收取(%)'){
								  return h('span', params.row.productCode);
                            }
                            else {
                                return h('span', params.row.productName);
                            }
						    }
                    },
                    {
                        title: "单位",
                        key: "unitName",
                        render:(h, params) =>{
                            if(!params.row.unitName){
								  return h('span', '');
                            }
                            else if(params.row.unitName=='数量合计') {
								 return	 h('span', '合计');
                            }
                            else {
                                return h('span', params.row.unitName);
                            }
						    }
                    },
                    {
                        title: '数量',
                        align: 'center',
                        key: 'orderQuantity',
							   render: (h, params) => {
                            if(params.row.productCode=='定金收取(%)'){
								  return h('span', this.getDepositRatio());
                            }
							  else if(params.row.productName=='包装费'||params.row.productName=='配送费'){
								  return h('span', params.row.orderQuantity);
                            }
							  else if(params.row.productCode&&params.row.productCode!="定金收取(%)"){
                                return h('span', parseFloat(params.row.orderQuantity));
							   }
							  else if(params.row.preSalePlanPrice=='金额合计'){
								  return h('span', this.getSumTotalQuantity());
							  }
							  else{
                                return h('span', '');
							  }
                        }
                    },
                    {
                        title: '单价',
                        align: 'center',
                        key: 'preSalePlanPrice',
							   render: (h, params) => {
							   if(params.row.productCode&&params.row.productCode!="定金收取(%)"){
                                return h('span', params.row.preSalePlanPrice);
                            }
                            else if(params.row.preSalePlanPrice=='金额合计'){
                                return h('span', '');
                            }
                        }
                    },
                    {
                        title: '金额',
                        key: 'totalMoney',
                        render:(h, params) =>{
                            if(params.row.preSalePlanPrice=='金额合计'){
                                return	 h('span', this.getSumTotalMoney());
                            }
                            else if(params.row.productCode==''||params.row.productCode=='定金收取(%)'){
                                return	 h('span', '');
                            }
                            else{
                                return h('span', params.row.totalMoney);
                            }
						    }
                    },
                    {
                        title: '商品优惠',
                        key: 'depositBillDetailProductUnitPrice',
                        render:(h, params) =>{
                            if(params.row.productCode==''||params.row.productCode=='定金收取(%)'){
									 h('span', '');
                            }
                            else{
                                return h('span', params.row.depositBillDetailProductUnitPrice);
                            }
						    }
                    },
                    {
                        title: '客户优惠',
                        key: 'depositBillDetailCustomerUnitPrice',
                        render:(h, params) =>{
                            if(params.row.productCode==''||params.row.productCode=='定金收取(%)'){
									 h('span', '');
                            }
                            else{
                                return h('span', params.row.depositBillDetailCustomerUnitPrice);
                            }
						    }
                    },
                    {
                        title: '其它优惠',
                        key: 'depositBillDetailDeliveryArtificialUnitAmount',
                        render: (h, params) => {
                            if(params.row.productCode!=''&&params.row.productCode!='定金收取(%)'){
                                return h('span', params.row.depositBillDetailDeliveryArtificialUnitAmount);
                            }

                        }
                    },
                    {
                        title: '结算单价',
                        key: 'SettlementUnitrice',
                        render:(h, params) =>{
                            if(params.row.preSalePlanPrice=='金额合计'){
                                return	 h('span', '');
                            }
                            else if(params.row.productCode==''||params.row.productCode=='定金收取(%)'){
								  return	 h('span', params.row.preSalePlanPrice);
                            }
                            else{
                                return h('span', this.getSettlementUnitrice(params.row));
                            }
						    }
                    },
                    {
                        title: '优惠金额',
                        key: 'SettlementUnitrice',
                        render:(h, params) =>{
                            if(params.row.preSalePlanPrice=='金额合计'){
                                return h('span', this.getSumSettlementDiscount());
                            }
                            else if(params.row.depositBillDetailUuid){
                                return h('span', this.getSettlementDiscount(params.row));
                            }
						    }
                    },
                    {
                        title: '结算金额',
                        key: 'totalMoney',
                        render:(h, params) =>{
							  if(params.row.preSalePlanPrice=='金额合计'){
                                return h('span', this.getSumSettlementMoney().toFixed(2));
                            }
                            else if(params.row.preSalePlanPrice=='总额'){
                                return	 h('span', this.getPaymentAmount().toFixed(2));
                            }
                            else if(params.row.productCode==''){
                                return	 h('span', params.row.totalMoney.toFixed(2));
                            }
                            else if(params.row.productCode=='定金收取(%)'){
                                return	 h('span', params.row.totalMoney);
                            }
                            else{
                                return h('span', this.getSettlementMoney(params.row, 2));
                            }

						    }
                    },
                    {
						    title: '未生成发货单数量',
						    key: 'action',
						    align: 'center',
						    width: 60,
						    render: (h, params) => {
                            if(params.row.depositBillDetailUuid){
                                return h('span', (params.row.orderQuantity-this.getGeneratePreDeliverydetailQuantity(params.row.productCode)).toFixed(2));
                            }
                            else if(params.row.unitName=='数量合计') {
								    return	h('span', (this.getSumTotalQuantity()-this.getGeneratePreDeliverydetailQuantityAll()).toFixed(2));
                            }
                            else if(params.row.productCode=='定金收取(%)'){
                                return h('span', this.getPreDeliveryMaxDeposit);
                            }

						    }
                    },
                    {
						    title: '已生成发货单数量',
						    key: 'action',
						    align: 'center',
						    width: 60,
						    render: (h, params) => {
                            if(params.row.depositBillDetailUuid){
                                return h('span', this.getGeneratePreDeliverydetailQuantity(params.row.productCode));
                            }
                            else if(params.row.unitName=='数量合计') {
								    return	 h('span', this.getGeneratePreDeliverydetailQuantityAll());
                            }
                            else if(params.row.productCode=='定金收取(%)'){
                                return h('span', this.getGeneratePreDeliveryDeposit);
                            }
						    }
                    },
                    {
						    title: '已提交发货单数量',
						    key: 'action',
						    align: 'center',
						    width: 60,
						    render: (h, params) => {
                            if (params.row.depositBillDetailUuid) {
                                return h('span', this.getSumbitPreDeliverydetailQuantity(params.row.productCode));
                            }
                            else if(params.row.unitName=='数量合计'){
                                return h('span', this.getSumbitPreDeliverydetailQuantityAll());
                            }
                            else if(params.row.productCode=='定金收取(%)'){
                                return h('span', this.getGeneratePreDeliveryDepositSumbit);
                            }
						    }
                    }
                ],
                rows: []
            },
            preOrderDetail: {
                columns: [
                    {
						    title: '序号',
                        align: 'center',
                        width:'50',
						    render:(h, params) =>{
                            if(params.row.depositBillDetailUuid){
                                return h('span', params.index+1);
                            }
						    }
                    },
                    {
                        title: "品种编号",
                        align: 'center',
                        key: "productCode"
                    },
                    {
                        title: "品种名称",
                        align: 'center',
                        key: "productName"
                    },
                    {
                        title: "单位",
                        align: 'center',
                        key: "unitName"
                    },
                    {
                        title: '数量',
                        align: 'center',
                        key: 'orderQuantity',
							   render: (h, params) => {
                            if(params.row.depositBillDetailUuid){
								   return h('InputNumber', {
                                    props: {
                                        value:parseFloat(params.row.orderQuantity),
                                        min: this.getUnitisRounded(params.row.unitName)==0?1:0.01,
                                        max:this.preOrderDetailMaxRows.find(x=>x.productCode==params.row.productCode).orderQuantity,
                                        activeChange:false,
                                        step: params.row.productIncreaseStepAmount,
                                        precision:this.getUnitisRounded(params.row.unitName)
									 },
									 style:{
										 textAlign: "center"
									 },
									 on: {
                                        'on-change': (event) => {
											 params.row.orderQuantity = event;
											 this.updatePreRow(params.row, 'orderQuantity');
											 this.getTotalMoney(params.row, false);
											 this.gettDepositByProductQauntity();
											 this.setDepositAboveMax();
                                        }
                                    }
                                });
							   }
							   else if(params.row.unitName=='合计'){
                                return h('span', this.getSumTotalQuantity(false));
							   }
							  else if(params.row.productName=='定金收取(%)'){
                                return h('span', this.getPreDepositRatio);
							   }
							   else if(params.row.productName=='包装费'||params.row.productName=='配送费'){
                                return h('span', this.getPreDeliveryPackingFeeCases+'箱');
							   }
                        }
                    },
                    {
                        title: '单价',
                        align: 'center',
                        key: 'preSalePlanPrice',
							   render: (h, params) => {
							   if(params.row.depositBillDetailUuid){
								   return h('InputNumber', {
                                    props: {
									   value: parseFloat(params.row.preSalePlanPrice),
									   min:this.getSettlementUnitDiscount(params.row),
									   activeChange:false,
									   step: 0.01
									 },
									 style:{
										 textAlign: "center"
									 },
									 on: {
										 'on-change': (event) => {
											 params.row.preSalePlanPrice = event;
											 this.updatePreRow(params.row, 'preSalePlanPrice');
											 this.getTotalMoney(params.row, false);
											 this.setDepositAboveMax();
                                        }
									 }
								   });
                            }

                        }
                    },
                    {
                        title: '金额',
                        key: 'totalMoney',
                        render:(h, params) =>{
                            if(params.row.depositBillDetailUuid){
                                return h('span', parseFloat((params.row.orderQuantity*params.row.preSalePlanPrice).toFixed(2)));
                            }
								 else if(params.row.unitName=='合计'){
                                return h('span', this.getSumTotalMoney(false));
							   }

						    }
                    },
                    {
                        title: '商品优惠',
                        align: 'center', align: 'center',
                        key: 'depositBillDetailProductUnitPrice'
                    },
                    {
                        title: '客户优惠',
                        align: 'center',
                        key: 'depositBillDetailCustomerUnitPrice'
                    },
                    {
                        title: '其它优惠',
                        align: 'center',
                        key: 'depositBillDetailDeliveryArtificialUnitAmount',
                        render: (h, params) => {
                            if(params.row.depositBillDetailUuid){
                                return h('InputNumber', {
                                    props: {
                                        value: params.row.depositBillDetailDeliveryArtificialUnitAmount,
                                        min: 0,
                                        max:this.getArtificialDiscountUnitMax(params.row),
                                        //	disabled: this.isNoDiscount(params.row.uuid),
                                        activeChange:false,
                                        formatter:value=>parseFloat(value.toString()),
                                        step: 0.01,
                                        precision:4
                                    },
                                    style: {
                                        textAlign: "center"
                                    },
                                    on: {
                                        'on-change': event => {
                                            if(!event){
                                                event=0;
                                            }
                                            params.row.depositBillDetailDeliveryArtificialUnitAmount = event;
                                            this.updatePreRow(params.row, 'depositBillDetailDeliveryArtificialUnitAmount');
                                            this.getTotalMoney(params.row, false);
                                            this.setDepositAboveMax();


                                        }
                                    }
                                });
                            }

                        }
                    },
                    {
                        title: '结算单价',
                        key: 'SettlementUnitrice',
                        render:(h, params) =>{
                            if(params.row.depositBillDetailUuid){
                                return h('span', this.getSettlementUnitrice(params.row));
                            }
                            else if(params.row.productName=='定金收取(%)'){
                                return h('span', params.row.SettlementUnitrice);
                            }
                            else if(params.row.SettlementUnitrice=='代金券'){
                                return h('span', '代金券');
                            }
                            else if(params.row.SettlementUnitrice=='总额'){
                                return h('span', '总额');
                            }
                            else if(params.row.productName=='包装费'){
                                return h('span', this.getPreDeliveryPackingFeePerCase);
                            }
                            else if(params.row.productName=='配送费'){
                                return h('span', this.getPreDeliveryDeliveryFeeFeePerCase);
                            }

						    }
                    },
                    {
                        title: '优惠金额',
                        key: 'discountAmount',
                        render:(h, params) =>{

                            if(params.row.depositBillDetailUuid){
                                return h('span', this.getSettlementDiscount(params.row));
                            }
                            else if(params.row.unitName=='合计'){
                                return h('span', this.getSumSettlementDiscount(false));
                            }
						    }
                    },
                    {
                        title: '结算金额',
                        key: 'totalMoney',
                        render: (h, params) => {
                            if (params.row.depositBillDetailUuid) {
                                return h('span', this.getSettlementMoney(params.row, 2));
                            }
                            else if (params.row.unitName == '合计') {
                                return h('span', this.getSumSettlementMoney(false).toFixed(2));
                            }
                            else if (params.row.productName == '定金收取(%)') {
                                if(!this.isPreDeliveryAll){
                                    return h('InputNumber', {
                                        props: {
                                            value: this.setDeposit,
                                            min: 0,
                                            max: this.getPreDeliveryMaxDeposit<this.getTotalAmount?this.getPreDeliveryMaxDeposit:this.getTotalAmount,
                                            activeChange: false,
                                            formatter: value => parseFloat(value.toString()),
                                            step: 0.01,
                                            precision: 4
                                        },
                                        style: {
                                            textAlign: "center"
                                        },
                                        on: {
                                            'on-change': event => {
                                                if (!event) {
                                                    event = 0;
                                                }
                                                this.setDeposit = event;
                                            }
                                        }
                                    });
                                }
                                else{
                                    return h('span', this.getPreDeliveryMaxDeposit);
                                }

                            }
                            else if (params.row.productName == '手动录入包装费') {
                                return h('InputNumber', {
                                    props: {
                                        value: this.setFarmPackageFee,
                                        min: 0,
                                        activeChange: false,
                                        formatter: value => parseFloat(value.toString()),
                                        step: 0.01,
                                        precision: 2
                                    },
                                    style: {
                                        textAlign: "center"
                                    },
                                    on: {
                                        'on-change': event => {
                                            if (!event) {
                                                event = 0;
                                            }
                                            this.setFarmPackageFee = event;
                                            this.setDepositAboveMax();
                                        }
                                    }
                                });
                            }
                            else if (params.row.productName == '手动录入配送费') {
                                return h('InputNumber', {
                                    props: {
                                        value: this.setFarmDeliveryFee,
                                        min: 0,
                                        activeChange: false,
                                        formatter: value => parseFloat(value.toString()),
                                        step: 0.01,
                                        precision: 2
                                    },
                                    style: {
                                        textAlign: "center"
                                    },
                                    on: {
                                        'on-change': event => {
                                            if (!event) {
                                                event = 0;
                                            }
                                            this.setFarmDeliveryFee = event;
                                            this.setDepositAboveMax();
                                        }
                                    }
                                });
                            }
                            else if(params.row.productName=='包装费'){
                                return h('span', this.getPreDeliveryPackingFee);
                            }
                            else if(params.row.productName=='配送费'){
                                return h('span', this.getPreDeliveryDeliveryFeeFee);
                            }
                            // else if(params.row.SettlementUnitrice=='代金券'){
                            //     // return h('span', this.getTotalAmount.toFixed(2));
                            //     return h('InputNumber', {
                            //         props: {
                            //             value: this.setVoucherAmountFee,
                            //             min: 0,
                            //             activeChange: false,
                            //             formatter: value => parseFloat(value.toString()),
                            //             step: 0.01,
                            //             precision: 2
                            //         },
                            //         style: {
                            //             textAlign: "center"
                            //         },
                            //         on: {
                            //             'on-change': event => {
                            //                 if (!event) {
                            //                     event = 0;
                            //                 }
                            //                 this.setVoucherAmountFee = event;
                            //                 this.setDepositAboveMax();
                            //             }
                            //         }
                            //     });
                            // }
                            else if(params.row.SettlementUnitrice=='总额'){
                                return h('span', this.getTotalAmount.toFixed(2));
                            }

                        }
                    },
                    {
						    title: '操作',
						    key: 'action',
						    align: 'center',
						    width: 60,
						    render: (h, params) => {
                            return h('div', [
									    h('Button', {
									        props: {
									            type: 'text',
									            size: 'small',
									            shape: 'circle'
									        },
                                    style:{
                                        visibility: params.row.depositBillDetailUuid&&this.preOrderDetail.rows.filter(item=>item.depositBillDetailUuid).length>1? 'visible' : 'hidden'
                                    },
                                    on: {
											    click: () => {
											        this.cancelProduct(params.row);
											    }
                                    }
									    }, '撤销')
                            ]);

						    }
                    }
                ],
                rows: []
            },
            preOrderDetailMaxRows:[] //最多可以生成的发货单的产品列表
        };
    },
    computed: {
        //已经生成的发货单的定金之和
        getGeneratePreDeliveryDeposit(){
            let result=this.preSaleDeliveryRecords.reduce((sum, item) => sum + item.depositDue, 0);   //发货单定金求和
            return parseFloat(result.toFixed(2));
        },
        //已经提交的发货单的定金之和
        getGeneratePreDeliveryDepositSumbit(){
            let result=this.preSaleDeliveryRecords.filter(item=>item.preSaleDeliveryRecordStatus>-1).reduce((sum, item) => sum + item.depositDue, 0);   //发货单定金求和
            return parseFloat(result.toFixed(2));
        },
        //是否可以提前结束发货
        isCanBeforehand(){
            //已经提交的发货单的定金是否等于定金单的定金
            if(this.getGeneratePreDeliveryDepositSumbit<this.orderRecord.depositBillRecordDepositPaymentSum){
                return false;
            }
            //未提交的发货单条数
            let noSubmitLen= this.preSaleDeliveryRecords.filter(item=>item.preSaleDeliveryRecordStatus==-1).length;
            if(noSubmitLen>0){
                return false;
            }
            return true;
        },
        getPreDeliveryMaxDeposit(){
            let depositDeposit=this.orderRecord.depositBillRecordDepositPaymentSum; //定金单中的定金
            let preDeliveryDepositList=this.getGeneratePreDeliveryDeposit;   //发货单定金求和
            return parseFloat((depositDeposit-preDeliveryDepositList).toFixed(4));
        },
		   //找出有包装费和配送费的产品列表集合
        getPreDeliveryPackingFeedeliveryFeeProductList(){
            let packingFeeList=[];
            this.preOrderDetail.rows.filter(x=>x.depositBillDetailUuid).forEach(item=>{
				   let product=	this.depositProducts.find(x=>x.productCode==item.productCode);
                if(product&&product.productPackageQuantity>0&&(product.packingFee>0||product.deliveryFee>0)){
                    packingFeeList.push({
							 productCode: product.productCode,
                        productPackageQuantity: product.productPackageQuantity,
                        quantity: item.orderQuantity,
                        packingFee: product.packingFee,
                        deliveryFee: product.deliveryFee
                    });
                }
            });
            return packingFeeList;
        },
        //计算总箱数
        getPreDeliveryPackingFeeCases(){
            let packingFeeList=this.getPreDeliveryPackingFeedeliveryFeeProductList;
            let cases= packingFeeList.reduce((a, b)=>a+Math.ceil(b.quantity/b.productPackageQuantity), 0);  //总箱数
            return cases;
        },
        //计算总包装费
        getPreDeliveryPackingFee(){
            let packingFeeList=this.getPreDeliveryPackingFeedeliveryFeeProductList;
            let packingFeeAll= packingFeeList.reduce((a, b)=>a+(Math.ceil(b.quantity/b.productPackageQuantity)*b.packingFee), 0);
            return parseFloat(packingFeeAll.toFixed(4));
        },
        //计算总配送费
        getPreDeliveryDeliveryFeeFee(){
            let packingFeeList=this.getPreDeliveryPackingFeedeliveryFeeProductList;
            let packingFeeAll= packingFeeList.reduce((a, b)=>a+(Math.ceil(b.quantity/b.productPackageQuantity)*b.deliveryFee), 0);
            return parseFloat(packingFeeAll.toFixed(4));
        },
        //计算每箱包装费
        getPreDeliveryPackingFeePerCase(){
            let result=0;
            if(this.getPreDeliveryPackingFee>0&&this.getPreDeliveryPackingFeeCases>0){
                result=this.getPreDeliveryPackingFee/this.getPreDeliveryPackingFeeCases;
            }
            return result;
        },
        //计算每箱包配送费
        getPreDeliveryDeliveryFeeFeePerCase(){
            let result=0;
            if(this.getPreDeliveryDeliveryFeeFee>0&&this.getPreDeliveryPackingFeeCases>0){
                result=this.getPreDeliveryDeliveryFeeFee/this.getPreDeliveryPackingFeeCases;
            }
            return result;
        },
        getTotalAmount(){
            let result= this.getSumSettlementMoney(false)+this.getPreDeliveryPackingFee+this.getPreDeliveryDeliveryFeeFee+this.setFarmPackageFee+this.setFarmDeliveryFee - this.setVoucherAmountFee;
            return parseFloat(result.toFixed(4));
        },
        //计算发货单定金比例
        getPreDepositRatio(){
            if(this.getTotalAmount==0){
                return 0;
            }
            let result=Math.ceil(this.setDeposit*100/this.getTotalAmount) ;
            return result;
        },
        //生成的发货单是否是剩余全部未发货量
        isPreDeliveryAll(){
            let list= this.preOrderDetail.rows.filter(x=>x.depositBillDetailUuid);
            if(this.preOrderDetailMaxRows.length>list.length){
                return false;
            }
            let result=true;
            for(let i=0;i<this.preOrderDetailMaxRows.length;i++){

                let item=this.preOrderDetailMaxRows[i];
                let detail= list.find(x=>x.productCode==item.productCode);
                if(detail==null||item.orderQuantity!=detail.orderQuantity){
                    result= false;
                    break;
                }

            }
            return result;
        }
    },
    mounted() {
        this.getRegionList();
    },
    methods: {
        //获取列表中的产品列表
        getDetailList(){
            let list = this.orderDetail.rows.filter(item => item.depositBillDetailUuid);
            return list;
        },
        //批量设置其它优惠
        changeArtiDiscUnitDisAmount(event){
            if(!event){
                event=0;
            }
            let list =this.getDetailList();
			   let maxUnitDisAmount=this.getMaxArtiDiscUnitDisAmount();
			   if(event>maxUnitDisAmount){
				  event=maxUnitDisAmount;
			   }
			   this.depositBillDetailsArtiDiscUnitDisAmount=event;
            list.forEach(row=>{
                row.depositBillDetailDeliveryArtificialUnitAmount=event;
                this.getTotalMoney(row);
            });

        },
        //获取别表中能够设置的最大其它优惠的最小值
        getMaxArtiDiscUnitDisAmount(){
			  let list=this.getDetailList();
			  let maxUnitDisAmountArr=list.map(row=>row.preSalePlanPrice-row.depositBillDetailProductUnitPrice -row.depositBillDetailCustomerUnitPrice);
			  let result=Math.min(...maxUnitDisAmountArr);
			  return parseFloat(result.toFixed(4));
        },
        //计算合计数量
        getSumTotalQuantity(isOrderDetail=true) {
            let list ;
            if(isOrderDetail){
					 list = this.getDetailList().map(x => parseFloat(x.orderQuantity));
            }
            else{
                list = this.preOrderDetail.rows.filter(x=>x.depositBillDetailUuid).map(x => parseFloat(x.orderQuantity));
            }

            let reslut = list.reduce((a, b) => a + b, 0);
            return parseFloat(reslut.toFixed(2));
        },
        //计算合计金额
        getSumTotalMoney(isdepositOrder=true){
            let list;
            if(isdepositOrder){
					 list= this.getDetailList().map(x=>x.totalMoney);
            }
            else{
                list= this.preOrderDetail.rows.filter(x=>x.depositBillDetailUuid).map(x=>x.totalMoney);
            }
            let reslut= list.reduce((a, b) => a + b, 0);
            return parseFloat(reslut.toFixed(2));
        },
        //计算结算单价
        getSettlementUnitrice(row){
				  let result=(row.preSalePlanPrice-row.depositBillDetailProductUnitPrice -row.depositBillDetailCustomerUnitPrice-row.depositBillDetailDeliveryArtificialUnitAmount).toFixed(4);
				  return parseFloat(result);
        },
        //计算折扣金额
        getSettlementDiscount(row){
				  let result=((row.depositBillDetailProductUnitPrice +row.depositBillDetailCustomerUnitPrice+row.depositBillDetailDeliveryArtificialUnitAmount)*row.orderQuantity).toFixed(2);
				  return parseFloat(result);
        },

        //计算折扣单价
        getSettlementUnitDiscount(row){
				  let result=(row.depositBillDetailProductUnitPrice +row.depositBillDetailCustomerUnitPrice+row.depositBillDetailDeliveryArtificialUnitAmount).toFixed(4);
				  return parseFloat(result);
        },
        //计算合计折扣金额
        getSumSettlementDiscount(isdepositOrder=true){
            let list = this.getDetailList();
            if(isdepositOrder){
					 list = this.getDetailList();
            }
            else{
                list= this.preOrderDetail.rows.filter(x=>x.depositBillDetailUuid);
            }

            let reslut = list.reduce((a, b) => a +this.getSettlementDiscount(b), 0);
            return parseFloat(reslut.toFixed(2));
        },
		    //计算结算金额
        getSettlementMoney(row, dit=2){
				 let result= (this.getSettlementUnitrice(row)*row.orderQuantity).toFixed(dit);
				 return parseFloat(result);
        },
        //计算合计结算金额
        getSumSettlementMoney(isdepositOrder=true){
            let list ;
            if(isdepositOrder){
					 list = this.getDetailList();
            }
            else{
                list= this.preOrderDetail.rows.filter(x=>x.depositBillDetailUuid);
            }
            let result= list.reduce((a, b) => a + this.getSettlementMoney(b, 4), 0);
				 return parseFloat(result.toFixed(4));
        },
        //计算定金比例
        getDepositRatio(){
            let deposit= this.orderRecord.depositBillRecordDepositPaymentSum;
            let totalMoney= this.getSumTotalMoney();
            if(totalMoney==0){
                return 0;
            }
            return parseFloat((deposit/totalMoney*100).toFixed(0));
        },
        //计算折扣
        getDiscount(){
            let result=this.getSumTotalMoney()-this.getSumSettlementMoney();
				 return parseFloat(result.toFixed(2));
        },
        //计算总额
        getPaymentAmount(){
            let row1= this.orderDetail.rows.find(item => item.productName == '手动录入包装费');
            let row2= this.orderDetail.rows.find(item => item.productName == '手动录入配送费');
            let row3= this.orderDetail.rows.find(item => item.productName == '包装费');
            let row4= this.orderDetail.rows.find(item => item.productName == '配送费');
            let getTotalMoney=a=>a?a.totalMoney:0;
            let result=this.getSumSettlementMoney()+getTotalMoney(row1)+getTotalMoney(row2)+getTotalMoney(row3)+getTotalMoney(row4);
            //let result=this.getSumSettlementMoney()+(row1?.totalMoney??0)+(row2?.totalMoney??0)+(row3?.totalMoney??0)+(row4?.totalMoney??0);
				 return parseFloat(result.toFixed(2));
        },
        //其它优惠的最大值
        getArtificialDiscountUnitMax(row){
            let result=(row.preSalePlanPrice-row.depositBillDetailProductUnitPrice -row.depositBillDetailCustomerUnitPrice).toFixed(4);
            return parseFloat(result);
        },
        //发货单变化时,判断定金是否超过最大值，超过了重新设置
        setDepositAboveMax(){
            if(this.isPreDeliveryAll){
                //如果是剩余的产品全部发货,定金金额是定金单中的剩余金额，不出来
                return;
            }
            //定金大于总额，则把定金金额设置成总额
            if(this.setDeposit>this.getTotalAmount){
                this.setDeposit=this.getTotalAmount;
            }
        },
        //根据设置的产品数量自动设置定金
        gettDepositByProductQauntity(){
            let totalMoney=0;
            //定金单剩余未发产品合计结算金额
            this.preOrderDetailMaxRows.forEach(item=>{
                totalMoney+=this.getSettlementMoney(item);
            });
			   let list= this.preOrderDetail.rows.filter(x=>x.depositBillDetailUuid);
            //新生成的发货单的产品合计结算金额(按照定金单的结算单价计算)
            let preTotalMoney=0;
            list.forEach(item=>{
                let detail= this.preOrderDetailMaxRows.find(x=>x.productCode==item.productCode);
                let unitrice=this.getSettlementUnitrice(detail);    //结算单价
                preTotalMoney+=unitrice*item.orderQuantity;
            });
            if(totalMoney==0){
                return;
            }
			  let deposit=preTotalMoney/totalMoney*this.getPreDeliveryMaxDeposit;
			  this.setDeposit=parseFloat(deposit.toFixed(2));
        },
        getRegionList(){
            webGetAllRegion().then(res => {
                if (res.code === 0) {
                    this.allRegions = res.data.allRegions;
                    this.provinceOptions = this.allRegions.filter(r => r.regionType === 1);
                    this.cityOptions = [];
                    this.distOptions = [];
                }
            });
        },
        onProvinceChange(provinceUuid) {
            this.distOptions = [];
            this.cityOptions = this.allRegions.filter(r => r.regionType === 2 && r.regionParentUuid === provinceUuid);
        },
        onCityChange(cityUuid) {
            this.distOptions = this.allRegions.filter(r => r.regionType === 3 && r.regionParentUuid === cityUuid);
        },
        updateRow(row, cloumnName) {
            let detail = this.orderDetail.rows.find(item => row.depositBillDetailUuid == item.depositBillDetailUuid);
            detail[cloumnName] = row[cloumnName];
        },
        updatePreRow(row, cloumnName) {
            let detail = this.preOrderDetail.rows.find(item => row.depositBillDetailUuid == item.depositBillDetailUuid);
            detail[cloumnName] = row[cloumnName];
        },
        //计算金额
        getTotalMoney(row, isOrder=true){
			   let orderDetails=this.orderDetail.rows;
            if(!isOrder){
                orderDetails=this.preOrderDetail.rows;
            }
            orderDetails.forEach(item =>{
                if(row.depositBillDetailUuid==item.depositBillDetailUuid){
						 item.totalMoney=numberDecimalMul(row.orderQuantity, row.preSalePlanPrice);
                }
            });
        },
        updatePreSalePlanPrice(){
            let preSalePlanPrice=this.orderDetail.rows[0].preSalePlanPrice;
            this.orderDetail.rows.forEach(item =>{
                if(item.productCode){
                    item.preSalePlanPrice=preSalePlanPrice;
                }
            });
        },
        //计算发货详情单中的产品数量 fn对详情单进行赛选的方法，fn2对发货单筛选的方法
        getPreDeliverydetailQuantity(fn, fn2=null){
            //获取所有的发货详情单
            let details=this.preSaleDeliveryRecords;
            if(fn2){
                details=details.filter(fn2);
            }
			    details=details.map(x=>x.details).flat();
			   let quantity= details.filter(fn).reduce((acc, obj) => acc + obj.preSaleDeliveryDetailQuantity, 0);
			   quantity=parseFloat(quantity.toFixed(2));
			   return quantity?quantity:0;
        },
        //计算产品已经生成发货单的数量
        getGeneratePreDeliverydetailQuantity(productCode){
            //获取所有的发货详情单
			  let fn=item=>item.productCode==productCode;
			   return this.getPreDeliverydetailQuantity(fn);
        },
        //计算产品已经生成发货单的数量合计
        getGeneratePreDeliverydetailQuantityAll(){
            //获取所有的发货详情单
			 let productCodes=this.getDetailList().map(x=>x.productCode);
			  let fn=item=>productCodes.includes(item.productCode);
			   return this.getPreDeliverydetailQuantity(fn);
        },
        //计算产品已经提交的发货单的数量
        getSumbitPreDeliverydetailQuantity(productCode) {
            //获取所有的发货详情单
            let fn = item => item.productCode == productCode;
            let fn2 = delivery => delivery.preSaleDeliveryRecordStatus>-1;
            return this.getPreDeliverydetailQuantity(fn, fn2);
        },
        //计算产品已经提交的发货单的数量合计
        getSumbitPreDeliverydetailQuantityAll() {
            //获取所有的发货详情单
            let productCodes=this.getDetailList().map(x=>x.productCode);
            let fn=item=>productCodes.includes(item.productCode);
            let fn2 = delivery => delivery.preSaleDeliveryRecordStatus>-1;
            return this.getPreDeliverydetailQuantity(fn, fn2);
        },
        saveDetailInfo(){
            let sendDeliveryDateNew=this.sendDeliveryDate+" 00:00:00";
            this.orderRecord.sendProductDate=sendDeliveryDateNew;
				  this.orderRecord.orderItmeList.forEach(item =>{
					  this.orderDetail.rows.forEach(e =>{
						  if(item.depositBillDetailUuid&&item.depositBillDetailUuid==e.depositBillDetailUuid){
							  item.orderQuantity = e.orderQuantity;
							  item.preSalePlanPrice = e.preSalePlanPrice;
						  }
					  });
				  });
				  this.innerSpin = true;
				  updateDepositBillDetailByUuid({ depositBillMainRecordVO:this.orderRecord }).then(res => {
					  this.innerSpin = false;
					  if (res.code === 0) {
						  this.innerSpin = true;
						  getDepositBillOrderDetail({ depositBillRecordUuid:this.depositBillRecordUuid }).then(res => {
							  this.innerSpin = false;
							  if (res.code === 0) {
								  this.orderRecord = res.data.depositBillMainVOList[0];
								 // this.orderDetail.rows = res.data.depositBillMainVOList[0].orderItmeList.filter(item=>item.productName!='折扣');
								  this.orderDetail.rows = res.data.depositBillMainVOList[0].orderItmeList;
								  this.$parent.getMainTableRecords();
								  this.$Message.success('修改的信息保存成功！');
							  }
						  }).catch(() => {
							  this.innerSpin = false;
						  });

					  }
				  });
        },
        cancel() {
            this.$Message.info('请再次确认信息');
        },
        cancelProduct(row){

            this.preOrderDetail.rows= this.preOrderDetail.rows.filter(item=>item.depositBillDetailUuid!=row.depositBillDetailUuid);
	            this.gettDepositByProductQauntity();   //重新设置定金
            this.setDepositAboveMax();		//定金是否超过最大限制
        },
        generatePreSaleDelivery(isSumbit){
            const { seedFarmName, deptYSType } = this.orderRecord;
            /* if(seedFarmName=='洋桔梗种苗部'&&!deptYSType){
					this.$Message.error({
						  content: '请选择部门',
						  duration: 2
					  });
					return;
				} */
            this.innerSpin = true;
            let depositBillMainRecordVO= {
                ...this.orderRecord,
                depositBillRecordDepositPaymentSum:this.setDeposit,    //定金
                packageFee :this.setFarmPackageFee,    //手动包装费
                deliveryFee :this.setFarmDeliveryFee,    //手动配送费
                voucherAmount :this.setVoucherAmountFee, //代金券
                deptYSType: deptYSType,
                orderItmeList:this.preOrderDetail.rows.filter(x=>x.depositBillDetailUuid)
            }; //此次设置的定金金额传入
            depositBillMainRecordVO.orderItmeList=depositBillMainRecordVO.orderItmeList.filter(item => item.productCode != '' && item.productCode != '定金收取(%)');

            let data={ depositBillMainRecordVO, isSumbit };
            generatePreSaleDelivery(data).then(res => {
                this.innerSpin = false;
				  if (res.code === 0) {
					  this.$Message.success({
						  content: res.message,
						  duration: 2
					  });
                    this.show=false;
					 this.$parent.getMainTableRecords();
				   }
				   else if(res.code === 4){
                    let amount=res.data.amout;
                    let userUuid=res.data.userUuid;
                    this.$refs.PayModal.showModal(userUuid, amount);

				   }
				   else{
                    this.$Message.error({
						  content: res.message,
						  duration: 2
					  });
				   }
            }).catch(() => {
                this.innerSpin = false;
            });


        },
        earlyTerminationDeposit(){
            let data={ depositBillRecordUuid:this.depositBillRecordUuid };
            earlyTerminationDeposit(data).then(res => {
                this.innerSpin = false;
				  if (res.code === 0) {
					  this.$Message.success({
						  content: res.message,
						  duration: 2
					  });
                    this.show=false;
					 this.$parent.getMainTableRecords();
				   }
				   else{
                    this.$Message.error({
						  content: res.message,
						  duration: 2
					  });
				   }
            }).catch(() => {
                this.innerSpin = false;
            });
        },
        formatDateString,
        formatDateTimeString,
        onShowChange(e) {
            if (e) {
                this.init();
            }
        },
        showModal(orderUuid) {
            this.depositBillRecordUuid = orderUuid;
            this.show = true;
        },
        showAbandonedDepositDetailModal(oldOrderUuid) {
            this.show = false;
			    this.$refs.abandonedDepositDetailModal.showModal(oldOrderUuid);
        },
        init() {
            this.depositBillDetailsArtiDiscUnitDisAmount=0;
            this.$forceUpdate();  // dom会强制更新
            if (this.depositBillRecordUuid) {
                this.innerSpin = true;

                let condition=search.getSearchParams();
                condition.filters.enable = true;
                condition.limit.Enable = false;
                condition.filters.conditions.push({
                    name: 'depositBillRecordUuid',
                    type: 'eq',
                    value:  this.depositBillRecordUuid
                });

                //手工包装费、手工配送费、代金券、定金初始化
                this.setFarmPackageFee=0;
                this.setFarmDeliveryFee=0;
                this.setsetVoucherAmountFee=0;
                this.setDeposit=0;

                Promise.all([getDepositBillOrderDetail({ depositBillRecordUuid:this.depositBillRecordUuid }), getPreDeliveryByDepositUuid({ depositBillRecordUuid:this.depositBillRecordUuid })]).then((res)=>{
                    this.innerSpin = false;
					    let [billRes, seleRes]=res;
                    if (billRes.code === 0) {
                        if (billRes.data.depositBillMainVOList != null&&billRes.data.depositBillMainVOList.length>0) {
                            this.orderRecord = billRes.data.depositBillMainVOList[0];
                            this.orderDetail.rows = billRes.data.depositBillMainVOList[0].orderItmeList;
                            //     this.orderDetail.rows = res.data.depositBillMainVOList[0].orderItmeList.filter(item=>item.productName!='折扣');
                            this.sendDeliveryDate=formatDateString(billRes.data.depositBillMainVOList[0].depositBillRecordSendProductDate);

                            this.cityOptions = this.allRegions.filter(r => r.regionType === 2 && r.regionParentUuid === this.orderRecord.depositBillRecordProvince);
                            this.distOptions = this.allRegions.filter(r => r.regionType === 3 && r.regionParentUuid === this.orderRecord.depositBillRecordCity);

                            //定金单的已付定金
                            this.depositBillDeposit=billRes.data.depositBillMainVOList[0].depositBillRecordDepositPaymentSum;
                        }

                    }
                    if(seleRes.code==0){
				            this.preSaleDeliveryRecords=seleRes.data.deliverys;
                        this.depositProducts=seleRes.data.products;
                        this.setDeposit=this.getPreDeliveryMaxDeposit;


                        this.setFarmPackageFee= 0;
                        this.setFarmDeliveryFee=0;
                        this.setVoucherAmountFee=0;
                        //之前未生成发货单此发货单默认的手工包装费和手工配送费是定金单中的手工包装费和手工配送费,否则默认为0
                        console.log(this.getGeneratePreDeliverydetailQuantityAll());

                        if(this.getGeneratePreDeliverydetailQuantityAll()<=0) {
                            let packRow=this.orderDetail.rows.find(x=>x.productName=="手动录入包装费");
                            if(packRow){
                                this.setFarmPackageFee= packRow.totalMoney;//手动包装费
                            }
                            let deliveryRow=this.orderDetail.rows.find(x=>x.productName=="手动录入配送费");
                            if(deliveryRow){
                                this.setFarmDeliveryFee = deliveryRow.totalMoney;  //手动配送费
                            }

                        }
                        //深复制避免两个对象相互影响
                        let rows=JSON.parse(JSON.stringify(this.orderDetail.rows)).filter(x=>x.depositBillDetailUuid);
                        rows.forEach(item=>{
                            let quantity= this.getGeneratePreDeliverydetailQuantity(item.productCode);
                            item.orderQuantity=parseFloat((item.orderQuantity-quantity).toFixed(2));
                        });
                        this.preOrderDetail.rows=rows.filter(item=>item.orderQuantity>0);
                        this.preOrderDetailMaxRows=JSON.parse(JSON.stringify(this.preOrderDetail.rows));
                        this.preOrderDetail.rows.push({ unitName:'合计' });
                        this.preOrderDetail.rows.push({ productName:'定金收取(%)', SettlementUnitrice:'已付定金' });
                        this.preOrderDetail.rows.push({ productName:'包装费' });
                        this.preOrderDetail.rows.push({ productName:'配送费' });
                        this.preOrderDetail.rows.push({ productName:'手动录入包装费' });
                        this.preOrderDetail.rows.push({ productName:'手动录入配送费' });
                        this.preOrderDetail.rows.push({ SettlementUnitrice:'代金券' });
                        this.preOrderDetail.rows.push({ SettlementUnitrice:'总额' });
                    }
                }).catch(() => {
                    this.innerSpin = false;
                });
            }
        },
        onDeptYSTypeChange(selectedValue){
            console.log("selectedValue", selectedValue);
            this.$set(this.orderRecord, 'deptYSType', selectedValue);
        }
    }
};
</script>

<style>
    .ivu-table-cell{
        text-align: center;
    }
    .ivu-table-small th{
        text-align: center;
       }
    .ivu-table th, .ivu-table td{text-align: center !important;}
    th.ivu-table-column-left, td.ivu-table-column-left{text-align: center !important;}
    th.ivu-table-column-right, td.ivu-table-column-right{text-align: center !important;}
	/* 自定义红色星号 */
	.custom-asterisk {
	color: red;
	margin-right: 4px;
	}
</style>
